/**
 * Per-device choices in the bell: the Eaze sound on/off (with a preview), and
 * whether this phone / computer shows Eaze notifications while the app is in
 * the background.
 */
import { useState } from "react";
import { Volume2, VolumeX, MonitorSmartphone } from "lucide-react";
import { playEazeSound, setSoundOn, soundOn } from "@/lib/eaze-sound";
import { askToNotify, notifyPermission } from "@/lib/system-notify";

export default function NotificationPrefs() {
  const [sound, setSound] = useState(soundOn());
  const [perm, setPerm] = useState(notifyPermission());
  return (
    <div className="flex items-center justify-between gap-2 px-4 py-2 border-b border-border text-[11px] text-muted-foreground">
      <button
        type="button"
        aria-pressed={sound}
        onClick={() => {
          const on = !sound;
          setSound(on);
          setSoundOn(on);
          if (on) playEazeSound("notify", { force: true });
        }}
        className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 hover:bg-muted focus:outline-none focus-visible:ring-1 focus-visible:ring-primary"
      >
        {sound ? <Volume2 className="h-3.5 w-3.5" /> : <VolumeX className="h-3.5 w-3.5" />}
        Sound {sound ? "on" : "off"}
      </button>
      {perm !== "unsupported" && (
        <button
          type="button"
          disabled={perm !== "default"}
          onClick={async () => setPerm(await askToNotify())}
          className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 hover:bg-muted disabled:hover:bg-transparent focus:outline-none focus-visible:ring-1 focus-visible:ring-primary"
          title={perm === "denied" ? "Allow notifications for this site in your browser settings" : undefined}
        >
          <MonitorSmartphone className="h-3.5 w-3.5" />
          {perm === "granted" ? "Shown on this device" : perm === "denied" ? "Blocked in browser settings" : "Show on this device"}
        </button>
      )}
    </div>
  );
}
